import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Panel = styled.div``;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CategoriesSection = styled.div`
  padding-top: ${space[2]};
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
  padding-bottom: ${space[3]};
`;

export const OtherInputWrapper = styled.div`
  padding-top: ${space[2]};
`;

export const FreeTextWrapper = styled.div`
  padding-top: ${space[2]};
`;
